import {Locale} from '@hebcal/hdate';
import poData from './ashkenazi_standard.po.js';
Locale.addLocale('ashkenazi_standard', poData);
